import { cookiesKeyNames } from '@revbox/common-fe'
import React from 'react'

const useTourOnBidModal = ({
    hasInventoryUrl,
    hasDirectoryPlacement,
    hasMagazinePlacement,
    hasAltVersions,
    isTourTriggered,
    startTour,
    getIsTourCompleted,
    publisher
}) => {
    React.useEffect(() => {
        const pubId = Number(publisher?.id) || 0
        if ([67, 1, 0].includes(pubId)) return

        if (hasInventoryUrl || hasDirectoryPlacement || hasMagazinePlacement || hasAltVersions) {
            const tourKey = cookiesKeyNames.tourAdvBidding
            const isTourCompleted = getIsTourCompleted(tourKey)
            if (isTourTriggered || !isTourCompleted) {
                document.getElementsByClassName('modal-content')[0].id = 'bid-modal-content'
                startTour(tourKey)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasInventoryUrl, hasDirectoryPlacement, hasMagazinePlacement, hasAltVersions, isTourTriggered])

    return null
}

export default useTourOnBidModal
